import {
  showMessage,
  logMessage,
  debounce,
  start,
  end,
  getResponseByMode,
  isError
} from './utils';
import {
  updateBasket,
  updateFavorite
} from './basket';

export function updateBasketFromList(elem) {

  if (elem === null) {
    return;
  }

  elem.addEventListener('click', listClickHandler);

  function listClickHandler(evt) {
    if (evt.target.classList.contains('view__button--cart') && !evt.target.classList.contains('view__button--added') && !evt.currentTarget.classList.contains('recommended__list')) {
      evt.preventDefault();
      const cartButton = evt.target;
      start();
      whenListProductDataLoad(cartButton);
    }

    if (evt.target.closest('.js-favorite')) {
      evt.preventDefault();
      const favoriteButton = evt.target.closest('.js-favorite');
      start();
      whenFavoriteDataLoad(favoriteButton);
    }
  }
}

const whenListProductDataLoad = debounce(function (elem) {
  const mock = 'mocks/product.json';

  const loadUrl = new URL(elem.href);
  loadUrl.searchParams.set('ajax', 1);
  loadUrl.searchParams.set('related', 1);
  const real = loadUrl.href;

  const url = getResponseByMode(mock, real);

  fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось добавить товар в корзину`);
    })
    .then((data) => {
      isError(data);
      return data.count;
    })
    .then((count) => {
      updateBasket(count);
      updateCartButton(elem);
    })
    .catch((error) => {
      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => end());
});

function updateCartButton(elem) {
  elem.classList.add('view__button--added');
  elem.textContent = 'В корзине';
  elem.href = '/shop/cart/';
}

export function updateBasketFromProduct() {
  const sectionAboutProduct = document.querySelector('.about-product');
  const favoriteButton = sectionAboutProduct.querySelector('.action-product__favorite');

  favoriteButton.addEventListener('click', favoriteButtonClickHandler);

  function favoriteButtonClickHandler(evt) {
    evt.preventDefault();
    start();
    whenFavoriteDataLoad(evt.currentTarget);
  }
}

const whenFavoriteDataLoad = debounce(function (elem) {
  const mock = 'mocks/product.json';

  const loadUrl = new URL(elem.href);
  loadUrl.searchParams.set('ajax', 1);
  const real = loadUrl.href;

  const url = getResponseByMode(mock, real);

  fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось добавить товар в Избранное`);
    })
    .then((data) => {
      isError(data);
      return data.count;
    })
    .then((count) => {
      updateFavorite(count);
      elem.classList.toggle('active');
    })
    .catch((error) => {

      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => end());
});
